import {Component, Inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import {MatButtonModule} from '@angular/material/button';
import {TranslateModule} from '@ngx-translate/core';
import {LanguageOption} from '../../../model/language-option.model';

@Component({
  selector: 'app-language-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatIconModule, MatListModule, MatButtonModule, TranslateModule],
  templateUrl: './language-dialog.component.html',
  styleUrls: ['./language-dialog.component.scss']
})
export class LanguageDialogComponent {
  selectedLangValue: string | null;

  constructor(
    public dialogRef: MatDialogRef<LanguageDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { selectedLang: string; languages: LanguageOption[] },
  ) {
    this.selectedLangValue = data.selectedLang ?? null;
  }

  onSelect(langValue: string) {
    this.selectedLangValue = langValue;
    this.dialogRef.close({value: this.selectedLangValue});
  }

  save() {
    this.dialogRef.close({value: this.selectedLangValue});
  }

  close() {
    this.dialogRef.close();
  }
}
